import { IAnswerItem, IQuestion } from "../../../types"
import axios from '../../../helpers/axios'
import loadData from '../../../helpers/data-loader'

export default {
  async create (context: IQuestion<IAnswerItem>, { answersParams }) {
    const response = await axios().post(context.endpoints.answers, { answers: answersParams })
    return response.data;
  },
}
